var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkflow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M15 11v2H5v-2zM3 11v2H1v-2zm12-4v2H5V7zM3 7v2H1V7zm12-4v2H5V3zM3 3v2H1V3z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#FF3CA0",
  fillRule: "evenodd",
  transform: "translate(-1 -3)"
})));
export default SvgWorkflow;